import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";
import { FacturationDTO } from "@/Patient/Api/MedfarBilling/Dto/Responses/FacturationReponse";

class MedfarBillingAction extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public SearchDiagnosis(searchText: string): void {
        var requestData = {
            SearchText: searchText
        };

        this.Execute(ServerOperations.Server.MedfarBilling_SearchDiagnosis, requestData);
    }

    public AddNewFavoriteCode(code: string, description: string): void {
        var requestData = {
            Code: "",
            Description: "",
            EmployeeId: ""
        };

        requestData.Code = code;
        requestData.Description = description;
        requestData.EmployeeId = sessionStore.getCurrentEmployee().ContactFacetId;

        this.Execute(ServerOperations.Server.MedfarBilling_AddFavoriteCode, requestData);
    }

    public LoadFavorite(IsSpecialist: boolean): void {
        var requestData = {
            EmployeeId: sessionStore.getCurrentEmployee().ContactFacetId,
            IsSpecialist: IsSpecialist
        };

        this.Execute(ServerOperations.Server.MedfarBilling_LoadFavoriteCode, requestData);
    }

    public VerifyNeedForfaitGMFAnnuel(patientContactId: string): void {
        var requestData = {
            EmployeeContactFacetId: sessionStore.getCurrentEmployee().ContactFacetId,
            PatientContactId: patientContactId,
            StateLookupIdArray: []
        };

        var lookupArrayId: string[] = [];
        cacheStore.GetAppointmentStateLookups().forEach((lookup: FlatLookupView) => {
            if (lookup.LookupCode === "FINISHED" || lookup.LookupCode === "INCONSULTATION" || lookup.LookupCode === "APPTriage" || lookup.LookupCode === "COMPLETED" || lookup.LookupCode === "APPTriageDone")
                lookupArrayId.push(lookup.LookupID);
        });

        requestData.StateLookupIdArray = lookupArrayId;

        this.Execute(ServerOperations.Server.MedfarBilling_VerifyAnnualGmfFee, requestData);
    }

    public RemoveFavoriteCode(code: string): void {
        var requestData = {
            Code: code,
            EmployeeId: sessionStore.getCurrentEmployee().ContactFacetId
        };

        this.Execute(ServerOperations.Server.MedfarBilling_RemoveFavoriteCode, requestData);
    }

    public GenerateBill(model: FacturationDTO): void {
        var requestData = {
            Model: model
        };

        this.Execute(ServerOperations.Server.MedfarBilling_GenerateBill, requestData);
    }
}

export { MedfarBillingAction };
